import { resolve } from "../utils/resolve";
import { IConfigs } from "./types/IConfigs.types";

export class Configs implements IConfigs {
    constructor(protected env = process.env || {}) {}

    getPrefixXmlFolder(): string {
        return resolve<any, string>(
            this.env,
            (e) => e["PREFIX_XML_FOLDER"],
            ""
        );
    }

    getGameLaunchUrl(): string {
        return resolve<any, string>(
            this.env,
            (e) => e["PREFIX_GAME_LAUNCH_URL"],
            window.location.origin
        );
    }
}
